import { Injectable } from '@angular/core';

import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { Empty, MainApi } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GrpcCommonService } from './common.service';

@Injectable()
export class AccountGrpcContractService extends GrpcCommonService<MainApi.AccountGrpcContractClient> {
  constructor(protected _GrpcContract: MainApi.AccountGrpcContractClient) {
    super();
  }

  getStatus() {
    return from(this._GrpcContract.GetStatus(new Empty(), this.getMetadata())).pipe(grpcOperator());
  }
}
